import styled from 'styled-components'
import {
  Title,
  ReadMore,
  BiomarkersContainer,
  Container,
} from '../sharedStyles'
import HealthStatus, { ConfigText } from './HealthStatus'
import MeasuredBiomarkers from './MeasuredBiomarkers'
import Percentage from './Percentage'
import { useTranslation } from 'react-i18next'

const Background = styled.div`
  width: 100%;
  background: var(--surface-main, #f7f7f7);
  backdrop-filter: blur(6px);
  
  @media print {
    backdrop-filter: none!important;
    background: #f5f5f5!important;
  }
`

const Body = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`

const LeftSide = styled.div`
  width: 60%;
`
const RightSide = styled.div`
  span {
    margin-top: 20px;
  }
`

const Text = styled.p`
  color: var(--text-main, #1a1a1a);
  font-size: 16px;
  font-weight: 300;
  line-height: 26px;
  letter-spacing: 0.32px;
`

const GraphContainer = styled.div`
  width: 100%;
  margin-top: 20px;
  text-align: left;

  > span {
    display: inline-block;
    width: 240px;
    margin-right: 25px;
  }
  a {
    text-decoration: none;
  }
`

export const getScaleValue  = (total: any) => {
  if (!total) {
    return 'GREY'
  }

  const numericValue = Number(total.value)

  if (!Number.isNaN(numericValue)) {
    if (numericValue >= 98) {
      return 'G'
    }

    if (numericValue >= 90) {
      return 'GL'
    }

    if (numericValue >= 70) {
      return 'A'
    }

    return 'R'
  }

  let max = 'R';

  ['R', 'A', 'GL', 'G', 'GREY'].map((it: string) => {
      if (total[it] > total[max]) {
        max = it;
      }
  })
  return max;
}
export const NotFound = (props: any) => {
  return (<div className={'padds0'}>
    <div>
      <ConfigText field={'empty_to_add_biomarkers'}>
      According to the results of your blood test you need to add biomarkers to get informative results!
      </ConfigText>
    </div>
  </div>)
}
const PersonalizedHealthEvaluation = (props: any) => {
  const { i18n } = useTranslation()
  const info = props.info || {}
  const isScoreMissing =
    info?.total?.value === undefined || info?.total?.value === null

  const getSubjectName = (subject: any) => {
    if (!subject?.name) return '#' + subject._id
    
    if (typeof subject.name === 'string') {
      return subject.name
    }
    
    if (typeof subject.name === 'object' && subject.name[i18n.language]) {
      return subject.name[i18n.language]
    }
    
    return subject.name.en || subject.name.de || '#' + subject._id
  }

  return (
    <div data-grey>
      <Body className='flex9 padd' style={{flexDirection: 'row-reverse'}}>
        <RightSide data-animch='3'>
          <Percentage background={true} {...info.total} woBorder={true} />
        </RightSide>
        <LeftSide data-animch >
          <Title>
          <ConfigText field={'your_personalized'}>Your Personalized Health Evaluation Report</ConfigText>
            </Title>
          <HealthStatus
            status={info?.total?.scaleValue || getScaleValue(info?.total)}
            isScoreMissing={isScoreMissing}
          />
          <Text>
            <ConfigText field={'overall_text'}>
            Based on your blood test results, your overall
            health status requires attention and improvement. Our analysis
            focuses on seven key health systems that contribute to your
            well-being and performance:
            </ConfigText>
          </Text>
        </LeftSide>
      </Body>

      <GraphContainer data-animch='6' className={'paddB '}>
        {(info.subjects || []).map((it: any, index: number) => {
          return (<span>
              <Percentage
                hasBackground={false}
                isLabel={true}
                {...it}
                startDeg={240}
                endDeg={120}
                overflowK={0.75}
                name={getSubjectName(it)}
              />
            </span>
          )
        })}
      </GraphContainer>
    </div>
  )
}

export default PersonalizedHealthEvaluation
